import {Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {Customer} from '@/entity/Customer';
import Store from './index';

@Module({
    store: Store,
    name: 'CustomerStore',
    dynamic: true,
})
export class CustomerStore extends VuexModule {
    public currentCustomer = new Customer();
    
    @Mutation
    public setCurrentCustomer(c: Customer) {
        this.currentCustomer = Customer.of(c);
    }
    
}
